var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-list" } },
        _vm._l(_vm.dossiers, function (t, i) {
          return _c(
            "w-list-item",
            {
              key: i,
              on: {
                click: function ($event) {
                  return _vm.selectDossier(t.dossierName)
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [
                  t.dossierName == _vm.selectedDossier
                    ? _c("w-fa", { attrs: { icon: "check" } })
                    : _vm._e(),
                ],
                1
              ),
              _c("w-list-item-text", [
                _vm._v(" " + _vm._s(t.dossierName) + " "),
              ]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.getPreferedStartupDossierTooltip(t),
                          expression: "getPreferedStartupDossierTooltip(t)",
                        },
                      ],
                      class: {
                        gray: t.dossierName == _vm.preferedStartupDossier,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.setPreferedStartupDossier(t)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "thumbtack" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }